import { ScheduleItemV2 } from '@hopin-team/api-hopin';
import { compareAsc } from 'date-fns';

export type TimeStatus = 'past' | 'live' | 'future';

export type ItemWithTimeStatus = ScheduleItemV2 & {
  timeStatus?: TimeStatus;
};

export const getItemsWithTimeStatus = (
  items: ScheduleItemV2[] = [],
  now: Date,
): ItemWithTimeStatus[] => {
  return items.map(item => {
    const hasStarted = compareAsc(now, new Date(item.time_start)) > -1;
    const hasEnded = compareAsc(now, new Date(item.time_end)) === 1;
    const timeStatus = hasEnded ? 'past' : hasStarted ? 'live' : 'future';

    return {
      ...item,
      timeStatus,
    };
  });
};
